// extracted by mini-css-extract-plugin
export default {"pageWrap":"Zc-z","fullWidth":"_c-z","heading":"ad-z","fullBleed":"bd-z","hidden":"cd-z"};